import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/** Confirmation before restoring an older version; Esc and a click outside cancel. */
export const RestoreDialog = ({
  nr,
  currentNr,
  onCancel,
  onConfirm,
}: {
  nr: number;
  currentNr: number | null;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}) => {
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && !busy && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Fassung {nr} zurückholen?</DialogTitle>
          <DialogDescription>
            Der Text von Fassung {nr} wird als neue Fassung angelegt und ist
            danach die aktuelle.
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Alle bisherigen Fassungen bleiben erhalten
          {currentNr ? `, auch die jetzt aktuelle Fassung ${currentNr}` : ""}.
          Du kannst jede davon später wieder zurückholen.
        </p>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={busy}
            autoFocus
          >
            Abbrechen
          </Button>
          <Button onClick={confirm} disabled={busy}>
            {busy ? "Wird zurückgeholt …" : "Zurückholen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
